"use strict";
/**
 * Roles module (RBAC-1.9) — ЕДИНСТВЕННЫЙ словарь осей A и B.
 *
 * Три оси авторизации (эпик RBAC-1, AD-1):
 *
 *   | Ось | Что описывает                | Где объявлена            |
 *   |-----|------------------------------|--------------------------|
 *   | A   | тир доверия к личности       | `roles/tier.ts`          |
 *   | B   | платформенная должность      | `roles/platform.ts`      |
 *   | C   | членство в магазине          | `membership/` (RBAC-2.1) |
 *
 * Оси A и B — строки в таблице `roles`; ось C — отношение
 * `merchant_members (user, merchant, role)`, и ролью она не является. Разделение по
 * модулям буквальное: смешение трёх осей в одном списке и есть дефект, ради которого
 * написан эпик.
 *
 * До этой стори имена осей A и B были объявлены в четырёх местах (Core
 * `shared/constants`, `shared-auth-lib/utils/constants`, рукописный `index.d.ts`,
 * плюс руками выписанные списки в каждом гейте), и в трёх из четырёх содержались
 * имена, которых в базе нет. Такой гейт нельзя прочитать: он выглядит как правило, а
 * работает как случайность.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./tier"), exports);
__exportStar(require("./platform"), exports);
